<template>
  <v-app style="background-color: white">
    <component :is="this.headerFooterChoose.header"></component>
    <template v-if="adminMode && !$vuetify.breakpoint.smAndDown">
      <home-header-admin class="mt-12"></home-header-admin>
    </template>

    <transition name="routerAnimation" enter-active-class="animated fadeIn">
      <router-view
        style="max-width: 1400px"
        :class="{ 'mt-12': !$vuetify.breakpoint.smAndDown }"
      ></router-view>
    </transition>
    <div class="spacer"></div>
    <TokenExpired
      :view="tokenExpired"
      v-if="tokenExpired"
      @close="tokenExpired = false"
    ></TokenExpired>
    <!--<AlertPopup :view="showAlert" v-if="showAlert" />-->
    <component :is="this.headerFooterChoose.footer"></component>
  </v-app>
</template>

<script>
// import Home from "./views/Home";
import Footer from './components/Footer'
import HomeHeader from './components/HomeHeader'
import HomeHeaderUser from './components/HomeHeaderUser'
import HomeResponsive from './components/HomeResponsive'
import FooterResponsive from './components/FooterResponsive'
//import AlertPopup from './components/modals/AlertPopup'
import axios from 'axios'
import CryptoJS from 'crypto-js'

//import encHex from "crypto-js/enc-hex";
//import aes from "crypto-js/aes";
//import padZeroPadding from "crypto-js/pad-zeropadding";
import Pkcs7 from 'crypto-js/pad-pkcs7'
import { _ } from 'vue-underscore'
const HomeHeaderAdmin = () =>
  import(
    /* webpackChunkName: "HomeHeaderAdmin" */ './components/HomeHeaderAdmin'
  )
const TokenExpired = () =>
  import(
    /* webpackChunkName: "TokenExpired" */ './components/modals/tokenExpired'
  )
export default {
  name: 'App',

  components: {
    //AlertPopup,
    Footer,
    FooterResponsive,
    HomeHeader,
    HomeHeaderUser,
    'home-header-admin': HomeHeaderAdmin,
    HomeResponsive,
    TokenExpired
  },
  data: () => ({
    tokenExpired: false
  }),
  methods: {
    simpleEncrypt(string) {
      let key = CryptoJS.enc.Utf8.parse(process.env.VUE_APP_INSTA_SECRET) // 32 chars
      let iv = CryptoJS.enc.Utf8.parse(process.env.VUE_APP_INSTA_IV) // 16 chars
      let encrypted = CryptoJS.AES.encrypt(string, key, {
        iv: iv,
        padding: Pkcs7
      })
      return CryptoJS.enc.Base64.stringify(encrypted.ciphertext)
    },

    encrypt(string, key) {
      var iv = CryptoJS.lib.WordArray.random(16) // the reason to be 16, please read on `encryptMethod` property.

      var salt = CryptoJS.lib.WordArray.random(256)
      var iterations = 999
      var encryptMethodLength = this.encryptMethodLength / 4 // example: AES number is 256 / 4 = 64
      var hashKey = CryptoJS.PBKDF2(key, salt, {
        hasher: CryptoJS.algo.SHA512,
        keySize: encryptMethodLength / 8,
        iterations: iterations
      })

      var encrypted = CryptoJS.AES.encrypt(string, hashKey, {
        mode: CryptoJS.mode.CBC,
        iv: iv
      })
      var encryptedString = CryptoJS.enc.Base64.stringify(encrypted.ciphertext)

      var output = {
        ciphertext: encryptedString,
        iv: CryptoJS.enc.Hex.stringify(iv),
        salt: CryptoJS.enc.Hex.stringify(salt),
        iterations: iterations
      }

      return CryptoJS.enc.Base64.stringify(
        CryptoJS.enc.Utf8.parse(JSON.stringify(output))
      )
    },

    getCredentials() {
      return new Promise((resolve, reject) => {
        let credentials = {
          uid: null,
          token: null
        }
        this.$store
          .dispatch('checkUserStatus')
          .then(user => {
            credentials.uid = user.uid
            user
              .getIdToken(true)
              .then(token => {
                credentials.token = token
                resolve(credentials)
              })
              .catch(err => {
                console.log('Erro ao recuperar token: ', err)
                reject(err)
              })
          })
          .catch(err => {
            console.log('Erro ao recuperar usuario: ', err)
            reject(err)
          })
      })
    }
  },
  created() {
    /*axios.create({
      transformRequest: [(data, headers) => {
          console.log('headers:', headers);
          console.log('data:', data);
          let key = encHex.parse(process.env.VUE_APP_INSTA_SECRET);
          let iv = encHex.parse(process.env.VUE_APP_INSTA_SECRET2);
          let encrypted = aes
          .encrypt(JSON.stringify(data), key, {
            iv: iv,
            padding: padZeroPadding
          })
        console.log('encrypt:', encrypted);
          // modify data here
          return encrypted;
        }, ...axios.defaults.transformRequest]
    });*/
    axios.interceptors.response.use(
      response => {
        if (response.data.status === 401 || response.data.status === 403) {
          if (
            !_.contains(
              [
                'login',
                'signin',
                'NovaConta',
                'contact',
                'contato',
                'contactCompany',
                'contatoEmpresa',
                'selecionarperfil',
                'perfilselect',
                'reset',
                'redefinir',
                'confirm',
                'registro',
                'register'
              ],
              this.$route.name
            )
          ) {
            this.tokenExpired = true
          }
          return response
        }
        this.tokenExpired = false
        return response
      },
      error => {
        return Promise.reject(error)
      }
    )
    axios.interceptors.request.use(config => {
      let vm = this
      return new Promise((resolve, reject) => {
        let insertFileAPI = 'armazenamento/insert.php'
        let baseURL = config ? config.url.slice(-insertFileAPI.length) : ''
        /*let baseURL = process.env.VUE_APP_ITS_API
        let apiURL = config ?. config.url.slice(-baseURL.length)
        let whiteList = ['armazenamento/insert.php', '']
        */
        let checkFileUrl = baseURL == insertFileAPI
        let checkContentType =
          config.headers['content-type'] === 'multipart/form-data'
        if (config.method != 'get' && !checkFileUrl && !checkContentType) {
          //Need encrypt
          if (config.data.needAuth == false) {
            console.log('API does not need authorization!')
            config.data = this.simpleEncrypt(JSON.stringify(config.data))
            resolve(config)
          } else {
            /*Authorization Insert*/
            this.getCredentials()
              .then(credentials => {
                config.data.user_id = credentials.uid
                config.data.token = credentials.token
                config.data = this.simpleEncrypt(JSON.stringify(config.data))
                resolve(config)
              })
              .catch(err => {
                console.log('Credential error', err)
                vm.tokenExpired = true
                reject(err)
              })
          }
        } else resolve(config)
      })
    })
  },
  computed: {
    perfilSelected: function() {
      return (
        this.$store.getters.isAuthenticated &&
        this.$store.getters.isPerfilSelected
      )
    },

    adminMode: function() {
      return this.$store.getters.getAdminAuthentication.token ? true : false
    },

    showAlert: function() {
      return this.$store.getters.getGlobalAlert
    },

    headerFooterChoose() {
      return this.perfilSelected && !this.$vuetify.breakpoint.smAndDown
        ? { header: HomeHeaderUser, footer: Footer }
        : !this.perfilSelected && !this.$vuetify.breakpoint.smAndDown
        ? { header: HomeHeader, footer: Footer }
        : this.$vuetify.breakpoint.smAndDown
        ? { header: HomeResponsive, footer: FooterResponsive }
        : ''
    },

    encryptMethodLength() {
      var encryptMethod = this.encryptMethod
      // get only number from string.
      // @link https://stackoverflow.com/a/10003709/128761 Reference.
      var aesNumber = encryptMethod.match(/\d+/)[0]
      return parseInt(aesNumber)
    },

    encryptKeySize() {
      var aesNumber = this.encryptMethodLength
      return parseInt(aesNumber / 8)
    },

    encryptMethod() {
      return 'AES-256-CBC'
    }
  }
}
</script>
<style lang="sass">
@import '~vuetify/src/styles/styles.sass'
$body-font-family: 'Montserrat', sans-serif

$heading-font-family: $body-font-family, sans-serif

@each $heading, $style in $headings
  $headings: map-merge($headings, ($heading: map-merge($style, ('font-family': $heading-font-family))))

.v-application
  font-family: "Montserrat", sans-serif
  line-height: 1.5

.spacer
  flex-grow: 1
  flex-shrink: 0
  flex-basis: auto

.fade-enter
  opacity: 0

.fade-enter-active
  transition: opacity 1s

.fade-leave
 /*opacity: 1;*/

.fade-leave-active
  transition: opacity 1s
  opacity: 0

.slide-enter
  opacity: 0

.slide-enter-active
  animation: slide-in 1s ease-out forwards
  transition: opacity .5s

.slide-leave-active
  animation: slide-out 1s ease-out forwards
  transition: opacity 1s
  opacity: 0
  position: absolute

.slide-move
  transition: transform 1s

@keyframes slide-in
  from
    transform: translateY(20px)

  to
    transform: translateY(0)

@keyframes slide-out
  from
    transform: translateY(0)

  to
    transform: translateY(20px)
</style>
